module.exports = __webpack_public_path__ + "4c5789ccc917d93d65d1336ccebfc379.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/bgr_4.jpg
// module id = 832
// module chunks = 0